module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-d0d39eb4c1d7e7aa5ad807794d698274.png";